module.exports = __webpack_public_path__ + "map@2x.png";